<template>
  <page-outline :title="$t('pacs008.transaction_list_SCT')">
    <template slot="pageContent">
      <!-- FILTRES MOBILE -->
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            propedServiceId="10"
            filterType="list"
            :mode="this.mode"
            @applyFilter="applyFilter($event)">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage" style="overflow: hidden">
        <b-row>
          <b-col cols="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  format="SCT"
                  :mode="this.mode"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="10"
                  :countResults="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br />

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100" />
              </b-col>
            </b-row>

            <br />

            <b-row class="form-group justify-content-start m-0 p-0">
              <b-col sm="2" cols="6" class="m-0 p-0">
                <div
                  :class="{
                    'active-tab': currentTab === 'list',
                    'inactive-tab': currentTab !== 'list',
                  }"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="changeCurrentTab('list')">
                  <i class="fa-duotone fa-file"></i>
                  {{ $t("pacs008.transaction_list") }}
                </div>
              </b-col>
              <b-col sm="2" cols="6" class="m-0 p-0">
                <div
                  :class="{
                    'active-tab': currentTab === 'data',
                    'inactive-tab': currentTab !== 'data',
                  }"
                  class="mr-2 text-left cursor"
                  size="sm"
                  @click="changeCurrentTab('data')">
                  <i class="fa-duotone fa-file-lines"></i>
                  {{ $t("pacs008.transaction_details") }}
                </div>
              </b-col>
            </b-row>
            <br />
            <spinner v-if="activateSpinner"></spinner>
            <div v-else-if="currentTab === 'list'">
              <b-table
                hover
                responsive
                v-if="items.length"
                class="mt-3"
                :items="items"
                :fields="fields"
                selectable
                select-mode="single"
                @row-selected="showData"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable">
                <template #cell(statut)="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span :title="data.value" :class="data.item.statusClass">{{ data.value }}</span>
                  </div>
                </template>
                <template #cell()="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis">
                    <span :title="data.value">{{ data.value }}</span>
                  </div>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t("common.no_result") }}
                </span>
              </div>
              <b-row class="mt-5">
                <b-col>
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh">
                  </cm-pagination>
                </b-col>
              </b-row>
              <b-row class="justify-content-end mt-5">
                <b-col lg="2" offset="7" class="mt-3">
                  <b-button variant="primary"
                    @click="exportList()">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    {{ $t('pain008.extract_list') }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div v-else-if="currentTab === 'data'">
              <br />
              <b-row>
                <b-col md="2" cols="4" class="text-left" v-if="canGoPrev">
                  <b-button @click="navDetails(-1)" class="btn">
                    <i class="fa-solid fa-chevrons-left"></i>
                    {{ $t('pain008.previous') }}
                  </b-button>
                </b-col>
                <b-col md="8" class="d-none d-lg-block"></b-col>
                <b-col  md="2" cols="4" class="text-right" v-if="canGoNext">
                  <b-button @click="navDetails(1)" class="btn">
                    {{ $t('pain008.next') }}
                    <i class="fa-solid fa-chevrons-right"></i>
                  </b-button>
                </b-col>
              </b-row>
              <div v-for="info in transactionData" class="container" :key="info.id">
                <br />
                <b-row class="justify-content-center text-center px-5" v-if="info.refTransaction && info.statut">
                  <b-col md="6" cols="12" class="p-0">
                    <div class="bandeau1">
                      Ref:
                      <strong>{{info.refTransaction}}</strong>
                    </div>
                  </b-col>
                  <b-col md="6" cols="12" class="p-0">
                    <div :class="info.statut !== 'Transmit' ? 'bandeau2': 'bandeau-success'">
                      {{info.statut}}
                    </div>
                  </b-col>
                </b-row>
                <br>
                <b-row class="justify-content-end px-5">
                  <b-col md="6" cols="12" class="p-0">
                    <div class="title-label-blue" v-if="info.code === 'AC01'" style="width: 200px">{{ $t('pacs008.refund_info') }}</div>
                    <div class="title-label-blue" v-if="info.code === 'DUPL'" style="width: 200px">{{ $t('pacs008.request_info') }}</div>
                    <table class="table">
                      <tbody>
                        <tr v-if="info.code">
                          <th class="text-center" style="width:50%">
                            {{ $t('pacs008.reason_desc') }}
                          </th>
                          <td class="text-center" style="width:50%">
                            {{ findCode(info.code) }}
                          </td>
                        </tr>
                        <tr v-if="info.returnedAmount">
                          <th class="text-center" style="width:50%">
                            {{ $t('pacs008.amount_refunded') }}
                          </th>
                          <td class="text-center" style="width:50%">
                            {{ info.returnedAmount + ' ' + info.returnedCurrency }}
                          </td>
                        </tr>
                        <tr v-if="info.compensationAmount">
                          <th class="text-center" style="width:50%">
                            {{ $t('pacs008.compensation_taken_by_bank') }}
                          </th>
                          <td class="text-center" style="width:50%">
                            {{ info.compensationAmount + ' ' + info.compensationCurrency  }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>

                <b-row class="justify-content-between text-center">
                  <b-col md="3" cols="4">
                    <div class="py-4">
                      <label>{{ $t('pacs008.process_date') }}</label>
                      <p class="bloc-gris p-2">{{ info.processDate }}</p>
                    </div>
                  </b-col>
                  <b-col md="3" cols="4">
                    <div class="py-4">
                      <label>{{ $t('pacs008.amount') }}</label>
                      <p v-if="info.amount" class="bloc-gris p-2">
                        {{ info.amount + ' ' + info.currency }}
                      </p>
                      <p v-else class="bloc-gris p-2">
                        {{ '-' }}
                      </p>
                    </div>
                  </b-col>
                  <b-col md="3" cols="4">
                    <div class="py-4">
                      <label>{{ $t('pacs008.exec_date') }}</label>
                      <p class="bloc-gris p-2">
                        {{ info.executionDate }}
                      </p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="justify-content-between mx-4">
                  <b-col lg="3" cols="12" class="bloc-transaction bloc-in mx-auto mb-3">
                    <div class="p-3 mt-4">
                      <p class="text-center font-weight-bold">
                        {{ $t('pacs008.comes_from_file') }}
                      </p>
                      <!-- <p class="text-center word-break" v-if="info.fileIn">{{ info.fileIn }}</p> -->
                      <p v-if="info.protocol === 'webservice'" class="text-center word-break">
                        <br>
                        <i class="fa-solid fa-globe" :title="info.protocol"></i>
                        <br>
                        <br>
                        {{ info.msgIdField }}
                      </p>
                      <p v-if="info.protocol === 'interface'" class="text-center word-break">
                        <br>
                        <i class="fa-solid fa-file-arrow-up" :title="info.protocol"></i>
                        <br>
                        <br>
                        {{ info.msgIdField }}
                      </p>
                      <p v-if="info.protocol === 'remote folder'" class="text-center word-break">
                        <br>
                        <i class="fa-solid fa-folder-arrow-up" :title="info.protocol"></i>
                        <br>
                        <br>
                        {{ info.msgIdField }}
                      </p>
                      <p class="text-center word-break" v-else>-</p>
                    </div>
                  </b-col>
                  <b-col lg="1" cols="12" class="my-auto text-center mb-3">
                    <i class="fa-duotone fa-arrow-right-long text-danger h2"></i>
                  </b-col>
                  <b-col lg="3" cols="12"
                    class="d-flex justify-content-around bloc-transaction bloc-info mx-auto mb-3">
                    <div class="p-3 my-auto">
                      <p class="text-center font-weight-bold">{{ $t('pacs008.transmitter') }}</p>
                      <p>{{ info.debtorName }}</p>
                      <p>{{ info.debtorBankAccount }}</p>
                      <p>{{ info.debtorBic }}</p>
                      <p>{{ info.debtorCountry }}</p>
                      <p>{{ info.debtorAddress }}</p>
                    </div>
                    <div class="p-3 my-auto">
                      <p class="text-center font-weight-bold">{{ $t('pacs008.recipient') }}</p>
                      <p>{{ info.creditorName }}</p>
                      <p>{{ info.creditorBankAccount }}</p>
                      <p>{{ info.creditorBic }}</p>
                      <p>{{ info.creditorCountry }}</p>
                      <p>{{ info.creditorAddress }}</p>
                    </div>
                  </b-col>
                  <b-col lg="1" cols="12" class="my-auto text-center mb-3">
                    <i class="fa-duotone fa-arrow-right-long text-info h2"></i>
                  </b-col>
                  <b-col lg="3" cols="12" class="bloc-transaction bloc-out mx-auto mb-3">
                    <div class="p-3 d-flex flex-column" :class="info.type === 'sct_instanea' ? 'mt-5' : 'mt-4'">
                      <p class="text-center font-weight-bold" v-if="info.type === 'sct_instanea'">
                        {{ $t('pacs008.id_pacs') }}
                      </p>
                      <p class="text-center font-weight-bold" v-else>
                        {{ $t('pacs008.content_in_pacs008') }}
                      </p>
                      <p class="text-center word-break" v-if="info.namePacs">
                        {{ info.namePacs }}
                      </p>
                      <p class="text-center" v-else>-</p>
                      <b-button v-if="info.namePacs && info.type !== 'sct_instanea'"
                        class="align-self-center"
                        variant="primary"
                        size="sm"
                        @click="redirectToFile(info.idOut, info.namePacs)">
                        {{ $t('pacs008.view_this_file') }}
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from "moment"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import pagination from "@/components/common/pagination.vue"
import MessagesFilter from "@/pages/pacs008/components/FilterTransaction/index.vue"
import { errorMessageAlert } from "@/helpers/alert"
import {loadPage} from '@/helpers/routing'
import {statusLabel} from '@/helpers/labels'

export default {
  name: "TransactionList",
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  computed: {
    isSmartphoneOS() {
      return this.$f7.device.os === "android" || this.$f7.device.os === "ios"
    }
  },
  data() {
    return {
      activateSpinner: false,
      canGoPrev: false,
      canGoNext: false,
      completeList: [],
      currentIndex: 0,
      currentTab: "list",
      fields: [
        {
          key: "processDate",
          label: this.$t("pacs008.process_date"),
          class: "text-center",
          sortable: true
        },
        {
          key: "endToEndIdField",
          label: this.$t("pacs008.end_to_end_id"),
          class: "text-center",
          sortable: true
        },
        {
          key: "msgIdField",
          label: this.$t("pacs008.msgId"),
          class: "text-center",
          sortable: true
        },
        {
          key: "nameDebtor",
          label: this.$t("pacs008.holder_name"),
          class: "text-center",
          sortable: false
        },
        {
          key: "ibanDebtorField",
          label: this.$t("pacs008.creditor_iban"),
          class: "text-center",
          sortable: false
        },
        {
          key: "bicCreditor",
          label: this.$t("pacs008.debtor_bic"),
          class: "text-center",
          sortable: false
        },
        {
          key: "directionn",
          label: this.$t("pacs008.direction"),
          class: "text-center",
          sortable: false
        },
        {
          key: "statut",
          label: this.$t("pacs008.status"),
          class: "text-center",
          sortable: false
        },
        // ENLEVé car ---> peut devenir aussi un virement instantanné donc routing différent
        // {
        //   key: "namePacs",
        //   label: this.$t("pacs008.file_name_pacs008"),
        //   class: "text-center",
        //   sortable: true,
        //   thClass: "w-50",
        // },
      ],
      filterConditions: {},
      items: [],
      mode: 1,
      msgId: '',
      paginationObject: {},
      sortBy: '',
      sortDir: false,
      statusClass: {
        '5': 'text-success', // changed status 1 -> 5
        '2': 'text-danger',
        '1': 'text-danger' // changed status 0 -> 1
      },
      transactionData: [],
      codeList : [
        {
          code: 'DUPL',
          label: 'Doublon'
        },
        {
          code: "TECH",
          label: "Problème technique"
        },
        {
          code: "FRAD",
          label: "Fraude"
        },
        {
          code: "FOCR",
          label: "Validation demande d'annulation"
        },
        {
          code: "AC01",
          label: "Identifiant du compte invalide"
        },
        {
          code: "AC04",
          label: "Compte fermée"
        },
        {
          code: "AC06",
          label: "Compte bloqué"
        },
        {
          code: "AG01",
          label: "Transaction interdite"
        },
        {
          code: "AG02",
          label: "Code de la transaction incorrecte"
        },
        {
          code: "AM05",
          label: "Dupplication de paiement"
        },
        {
          code: "BE04",
          label: "Adresse du compte invalide"
        },
        {
          code: "CNOR",
          label: "Banque du créditeru non enregistrée"
        },
        {
          code: "ERIN",
          label: "L'option d'extencion de la remittance d'information n'est pas supportée"
        },
        {
          code: "MD07",
          label: "Beneficiaire décédé"
        },
        {
          code: "MS02",
          label: "Par ordre  du bénéficiaire"
        },
        {
          code: "MS03",
          label: "Raison non specifiéelseif"
        },
        {
          code: "RC01",
          label: "BIC invalide"
        },
        {
          code: "RR01",
          label: "Raison régulatoire"
        }
      ]
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
     }

    this.paginationObject.firstIndex = 1
    this.paginationObject.maxResults = 13
    this.paginationObject.nbResultsTotal = 0

    this.paginationObject["refresh"] = "consultation-page"
    this.$bus.$off("consultation-page")
    this.$bus.$on("consultation-page", (index) => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })

    let that = this
    this.reload = false

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    let filterConditions = {}

    if (this.$engine.pacs008.CurrentMsgIdSCT) {
      filterConditions.msgId = this.$engine.pacs008.CurrentMsgIdSCT
    }

    if (Object.keys(filterConditions).length) {
      this.applyFilter(filterConditions)
    } else {
      this.onRefresh(false)
    }
  },
  methods: {
    findCode (code) {
      for (let el of this.codeList) {
          if (el.code === code) {
            return el.label
          }
      }
    },
    applyFilter(filterConditions, index = 1) {
      this.filterConditions = filterConditions

      this.reload = true
      this.pageCounter = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResultsTotal = 0
      this.activateSpinner = true
      // this.msgId = ''

      if (!Object.keys(filterConditions).length) {
        if (this.reload) {
          filterConditions = this.$engine.pacs008.filter.getConditionObject()
        } else {
          filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
        }
      }

      if (filterConditions.requestIdentifiersct) {
        filterConditions.msgId = filterConditions.requestIdentifiersct
      }

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
     if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.$engine.pacs008
        .listTransactions(
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        )
        .then((resp) => {
          let requests = {}

          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults ? resp.data.nbTotalResults : 0

          this.paginationObject.nbResults = resp.data.Transactions.length

          requests = resp.data.Transactions

          this.updateItems(requests)

          this.updateInbox(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit(
            "refresh-cache-paging-template",
            this.paginationObject
          )
          if (this.$engine.pacs008.CurrentMsgIdSCT) {
            this.$engine.pacs008.CurrentMsgIdSCT = ""
          }

          this.activateSpinner = false
        })
        .catch((error) => {
          this.activateSpinner = false
          errorMessageAlert(error, this, this.$i18n)
        })
      this.currentTab = "list"
    },
    changeCurrentTab(newTab) {
      if (this.currentTab !== newTab) {
        this.currentTab = newTab
      }
    },
    exportList () {
      let filterConditions = {}
      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }
      // if (this.msgId) {
      //   filterConditions.msgId = this.msgId
      // }

      if (filterConditions.requestIdentifiersct) {
        filterConditions.msgId = filterConditions.requestIdentifiersct
      }
      this.$engine.pacs008.getTransactionCsv(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportTransaction
        this.updateList(list)
        this.extractCSV(this.completeList)
      }).catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    extractCSV (completeList) {
      this.$f7.showPreloader(this.$i18n.t("common.loading_page_label"))
      let today = moment()
      let firstLine =
        this.$t("pacs008.process_date") + ";" +
        this.$t("pacs008.end_to_end_id") + ";" +
        this.$t("pacs008.msgId") + ";" +
        this.$t("pacs008.holder_name") + ";" +
        this.$t("pacs008.creditor_iban") + ";" +
        this.$t("pacs008.debtor_bic") + ";" +
        this.$t("pacs008.direction") + ";" +
        // this.$t("pacs008.amount") +
        // ";" +
        // this.$t("pacs008.debtor_iban") +
        // ";" +
        this.$t("pacs008.status") +
        // ";" +
        // this.$t("pacs008.file_name_pacs008") +
        "\r\n"
      let line = atob(this.completeList.data)
      let data = firstLine + line
      let linkSource = "data:text/csv;charset:utf-8;base64," + btoa(data)
      let downloadLink = document.createElement("a")
      let fileName = "Pacs008_" + today.unix() + ".csv"
      this.$f7.hidePreloader()

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    navDetails (index) {
      this.$engine.pacs008.currentIndex = this.$engine.pacs008.currentIndex + index
      this.showData([{id: this.$engine.pacs008.listId[this.$engine.pacs008.currentIndex]}])
    },
    onRefresh(noAttach = false, index = 1) {
      this.pageCounter = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResultsTotal = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }
      console.log(this.msgIdField)
      if (this.msgId) {
        filterConditions.msgId = this.msgId
      }

      this.$engine.pacs008
        .listTransactions(
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        )
        .then((resp) => {
          let requests = {}

          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults ? resp.data.nbTotalResults : 0

          this.paginationObject.nbResults = resp.data.Transactions.length

          requests = resp.data.Transactions

          this.updateItems(requests)

          this.updateInbox(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit(
            "refresh-cache-paging-template",
            this.paginationObject
          )
          this.activateSpinner = false
        })
        .catch((error) => {
          this.activateSpinner = false
          errorMessageAlert(error, this, this.$i18n)
        })

      this.currentTab = 'list'
    },
    redirectToFile (id, namePacs) {
      this.$engine.pacs008.CurrentPacs008File = namePacs
      loadPage(this, { url: '/pacs008/SCT/consultation/' + id })
    },
    showData (item) {
      this.activateSpinner = true
      let transaction = item[0].id
      let that = this

      this.$engine.pacs008.currentIndex = this.$engine.pacs008.listId.indexOf(transaction)

      this.canGoPrev = this.$engine.pacs008.currentIndex > 0
      this.canGoNext = this.$engine.pacs008.currentIndex < (this.$engine.pacs008.listId.length - 1)


      this.$engine.pacs008
        .listTransactions(1, 1, { IdTransaction: transaction })
        .then((resp) => {
          let requests = []
          if (resp && resp.data) {
            requests.push(resp.data.Transactions)
            that.updateData(requests)
            that.$f7.pullToRefreshDone()
            that.$bus.emit(
              "refresh-cache-paging-template",
              this.paginationObject
            )

            that.currentTab = "data"
          } else {
            // return that.$f7.alert('pas de réponse', 'erreur')
          }
          that.activateSpinner = false
        })
        .catch((error) => {
          that.activateSpinner = false
          // errorMessageAlert(error, that, that.$i18n)
        })
      this.currentTab = "data"
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateData(requests) {
      this.transactionData = []

      for (var i = 0; i < requests.length; i++) {
        let processDate = ""
        processDate = requests[i].ProcessDate
        if (processDate !== "") {
          processDate = moment(processDate).format("DD/MM/YYYY [à] HH[h]mm")
        } else {
          processDate = "-"
        }

        let executionDate = ""
        executionDate = requests[i].ExecutionDate
        if (executionDate !== "") {
          executionDate = moment(executionDate).format("DD/MM/YYYY")
        } else {
          executionDate = "-"
        }

        let statusLibelle = ''
        let statusClass = ''
        if (requests[i].Status != 'requests[i].Status') {
          statusLibelle = statusLabel(this.$i18n, "pacs008_0" + requests[i].Status)
          statusClass = this.statusClass[requests[i].Status]
        } else {
          statusLibelle = '-'
        }

        let result = {
          idOut: requests[i].idOut,
          idIn: requests[i].idIn,
          processDate: processDate,
          executionDate: executionDate,
          amount: requests[i].Amount,
          refTransaction: requests[i].RefTransaction,
          debtorName: requests[i].HolderName,
          creditorName: requests[i].ContactName,
          debtorBic: requests[i].HolderBic,
          creditorBic: requests[i].ContactBic,
          debtorBankAccount: requests[i].HolderBankAccount,
          creditorBankAccount: requests[i].ContactBankAccount,
          currency: requests[i].Currency,
          namePacs: requests[i].namePacs,
          fileIn: requests[i].fileIn,
          msgIdField: requests[i].msgId,
          type: requests[i].type,
          directionn: this.setDir(requests[i].direction),
          debtorCountry: requests[i].HolderCountry,
          debtorAddress: requests[i].HolderAddress,
          creditorCountry: requests[i].ContactCountry,
          creditorAddress: requests[i].ContactAddress,
          code: requests[i].Code,
          returnedAmount: requests[i].RetAmount,
          returnedCurrency: requests[i].RetCurrency,
          compensationAmount: requests[i].CompAmount,
          compensationCurrency: requests[i].CompCurrency,
          statut: statusLibelle,
          statusClass: statusClass,
          protocol: requests[i].Protocole
        }
        this.transactionData.push(result)
      }
    },
    updateInbox(requests) {
      this.inboxMessages = requests
    },
    updateItems(requests) {
      this.$engine.pacs008.listId = []

      this.items = []

      for (var i = 0; i < requests.length; i++) {

        this.$engine.pacs008.listId.push(requests[i].IdTransaction)

        let processDate = ""
        processDate = requests[i].ProcessDate

        if (processDate !== "") {
          processDate = moment(processDate).format("DD/MM/YYYY [à] HH[h]mm")
        } else {
          processDate = "-"
        }

        let statusLibelle = ''
        let statusClass = ''
        if (requests[i].Status != '') {
          statusLibelle = statusLabel(this.$i18n, "pacs008_0" + requests[i].Status)
          statusClass = this.statusClass[requests[i].Status]
        } else {
          statusLibelle = '-'
        }

        let result = {
          id: requests[i].IdTransaction,
          processDate: processDate,
          nameDebtor: requests[i].HolderName,
          nameCreditor: requests[i].ContactName,
          ibanDebtorField: requests[i].HolderBankAccount,
          ibanCreditor: requests[i].ContactBankAccount,
          bicCreditor: requests[i].ContactBic,
          bicDebtor: requests[i].HolderBic,
          endToEndIdField: requests[i].RefTransaction,
          currency: requests[i].Currency,
          amount: requests[i].Amount,
          namePacs: requests[i].namePacs,
          fileIn: requests[i].fileIn,
          msgIdField: requests[i].msgId,
          directionn: this.setDir(requests[i].direction),
          debtorCountry: requests[i].HolderCountry,
          debtorAddress: requests[i].HolderAddress,
          creditorCountry: requests[i].ContactCountry,
          creditorAddress: requests[i].HolderAddress,
          code: requests[i].Code,
          returnedAmount: requests[i].RetAmount,
          returnedCurrency: requests[i].RetCurrency,
          compensationAmount: requests[i].CompAmount,
          compensationCurrency: requests[i].CompCurrency,
          statut: statusLibelle,
          statusClass: statusClass,
          protocol: requests[i].Protocole
        }
        this.items.push(result)
      }
    },
    updateList(list) {
      this.completeList = list
    },
    setDir (dir) {
      if (dir == 0) {
        return this.$t("pacs008.reception")
      } else {
        return this.$t("pacs008.emission")
      }
    }
  },
}
</script>
